import React, { useState } from "react";
import Button from "components/common/Button";

export default function ProcoreCompanyPicker({
  companies,
  initialId,
  saving,
  onSave,
}) {
  const [selected, setSelected] = useState(initialId || "");

  if (!companies.length) {
    return <p>No Procore companies are available to this Procore user.</p>;
  }

  return (
    <div>
      <p>Choose the Procore company to connect:</p>
      {companies.map((c) => (
        <label key={c.id} style={{ display: "block", margin: "6px 0" }}>
          <input
            type="radio"
            name="procore-company"
            value={c.id}
            checked={selected === c.id}
            onChange={() => setSelected(c.id)}
          />{" "}
          {c.name}
        </label>
      ))}
      <Button
        className="primary"
        disabled={!selected || saving}
        onClick={() => onSave(selected)}
      >
        {saving ? "Saving..." : "Save"}
      </Button>
    </div>
  );
}
